import React, { useEffect, useState } from "react";
import styles from "./promotion(1+n+n).scss";
import OnePlusnPlusnSet from "../onePlusnPlusnSet/onePlusnPlusnSet";
import { addToCart, calculateBundleTotal } from "../../../../common/utils/apis";
import { useSelector, useDispatch } from "react-redux";
import QuantitySelector from "@tw/shared-ui-components/lib/components/quantitySelector/quantitySelector";
import Cartbtn from "@tw/shared-ui-components/lib/components/addToCartButton/cartBtn";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { ONE_PLUS_N_BUNDLE } from "../../../../common/constant";
import BundleWrapper from "../bundleWrapper/bundleWrapper";
import GrandTotal from "../grandTotal/grandTotal";
import {
  getPageDetails,
  isAddToCartDisabled,
} from "../../../../common/utils/helper";
import {
  trackAddToCart,
  ttqTrackEventBuryingPoint,
  trackProductView,
  PAGES,
} from "@tw/shared-ui-components/lib/utils/analytics";
import { useParamas } from '@tw/shared-ui-components/lib/utils/helper';
import SEOHead from "../../../../common/components/seoHead/seoHead";
import { reselectProduct } from '../../../common/redux/reducers/index'

export default function PromotionOneplusNplusN(props) {
  const { Link, NextHead, template } = props;
  const { params } = useParamas();
  const { COMBINATION_QUANTITIES, COMBINATION_CONSIGNEE_ADA, CONSIGNEE_TYPE, CONSIGNEE_MEMBER_TYPE, COMBINATION_MASTER_ITEM_CODE, COMBINATION_MASTER_QUANTITY } = params || {};
  const dispatch = useDispatch();

  const promotionDetails = useSelector(
    (state) => state?.plpState?.promotionDetails
  );

  const defaultItem = useSelector(
    (state) => state?.plpState?.promotionProducts?.defaultItem
  );
  const [bundleItems, setBundleItems] = useState([])
  const proportion = useSelector(
    (state) => state?.plpState?.promotionProducts?.proportion
  );
  const promotionTitle = useSelector((state) => state?.plpState?.title);

  const getDefaultBundleDetails = () => ({
    expanded: true,
    quantities: bundleItems.reduce(
      (state, item) => ({
        ...state,
        [`${item.groupId}-${item.itemCode}`]: 0,
      }),
      {}
    ),
  });
  const getInitialBundleList = () => [getDefaultBundleDetails()];

  const [bundleDetailsList, setBundleDetailsList] = useState(
    getInitialBundleList()
  );
  const isProportionMatched = bundleDetailsList.every(({ quantities }) => {
    const selectedProportion = bundleItems.reduce(
      (total, item) => total + (quantities[`${item.groupId}-${item.itemCode}`] || 0),
      0
    );
    return selectedProportion == proportion;
  });
  const [grandTotal, setGrandTotal] = useState({
    totalPrice: 0,
    totalPointVolume: 0,
    totalBusinessVolume: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(null);
  const [isQuantLoad, setIsQuantLoad] = useState(false);

  const pageDetails = getPageDetails(null, PAGES.promotion);

  const updateBundleDetailsList = async (newList) => {
    if (!defaultItem) return;
    setIsLoading(true);
    const promotionItemList = bundleItems.map((bundleItem) => ({
      itemCode: bundleItem.itemCode,
      quantity: 0,
    }));

    promotionItemList.push({
      itemCode: defaultItem.itemCode,
      quantity: newList.length,
    });
    newList.forEach(({ quantities }) => {
      bundleItems.forEach((bundleItem, index) => {
        if (!quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`]) return;
        promotionItemList[index].quantity += quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`];
      });
      //   3-1-4. N區內商品數: 可配置1個或多個，當N為1時則為固定商品不能讓顧客選擇
      promotionDetails?.zones?.map((zones) => {
        if (zones?.products?.length == 1) {
          const index = `${zones.products[0].groupId}-${zones.products[0].itemCode}`;
          if (Object.hasOwnProperty.call(quantities, index)) {
            quantities[index] = 1
          }
        }
      })
    });


    const total = await calculateBundleTotal(
      promotionDetails?.promotionCode,
      promotionItemList.filter((item) => item.quantity > 0)
    );
    if (total?.code && total?.message) {
      toastMsg(total?.message)
      setIsLoading(false);
      setLoadingProduct(null);
    } else {
      setBundleDetailsList(newList);
      setGrandTotal(total);
      setIsLoading(false);
      setLoadingProduct(null);
    }
  };

  const quantityChangeHandler = async (quantity) => {
    setIsQuantLoad(true);
    if (bundleDetailsList?.length < quantity) {
      const newBundleList = [
        ...Array(quantity - bundleDetailsList?.length).keys(),
      ].map(getDefaultBundleDetails);

      await updateBundleDetailsList([
        ...bundleDetailsList.map((bundle) => ({ ...bundle, expanded: false })),
        ...newBundleList,
      ]);
    } else {
      await updateBundleDetailsList(bundleDetailsList?.slice(0, quantity));
    }
    setIsQuantLoad(false);
  };

  const onItemQuantityChange = (bundleIndex) => (itemCode, quantity, groupId) => {
    setLoadingProduct(itemCode);
    updateBundleDetailsList(
      bundleDetailsList.map((bundle, index) => {
        if (index != bundleIndex) return bundle;
        return {
          ...bundle,
          quantities: { ...bundle.quantities, [`${groupId}-${itemCode}`]: quantity },
        };
      })
    );
  };

  const onBundleExpandToggle = (bundleIndex) => (expanded) => {
    setBundleDetailsList(
      bundleDetailsList.map((bundle, index) => {
        if (index != bundleIndex) return bundle;
        return { ...bundle, expanded };
      })
    );
  };
  //  更新購物車
  const updateShoppingCart = async () => {
    try {
      setIsAddToCartLoading(true);
      let childBatchSubProductDTO = bundleDetailsList.reduce(
        (childObj, { quantities }, index) => ({
          ...childObj,
          [index + 1]: bundleItems
            .map((item) => {
              const itemQuantity = quantities[`${item.groupId}-${item.itemCode}`];
              if (itemQuantity) {
                return {
                  itemCode: item.itemCode,
                  quantity: itemQuantity,
                  subItemCode: defaultItem.itemCode,
                  proportionGroupId: item.groupId
                };
              }
            })
            .filter(Boolean),
        }),
        {}
      );
      const param = {
        childBatchSubProductDTO,
        itemCode: defaultItem.itemCode,
        quantity: bundleDetailsList.length,
        consigneeAda: COMBINATION_CONSIGNEE_ADA,
        consigneeType: CONSIGNEE_TYPE,
        consigneeMemberType: CONSIGNEE_MEMBER_TYPE
      }
      dispatch(reselectProduct(param))
        .then(async (res) => {
          if (res.status === 200 && res.data.success && res.data.code == "0") {
            // tealium analytics
            trackAddToCart([defaultItem], [bundleDetailsList?.length], pageDetails);
            /*  ===============================================  TEP-15578 ============================================= */
            let products = bundleDetailsList.reduce(
              (childObj, { quantities }, index) => ({
                ...childObj,
                [index + 1]: bundleItems
                  .map((item) => {
                    const itemQuantity = quantities[`${item.groupId}-${item.itemCode}`];
                    if (itemQuantity) {
                      return {
                        ...item,
                        quantity: itemQuantity,
                      };
                    }
                  })
                  .filter(Boolean),
              }),
              {}
            );

            let productItem = []
            for (const key in products) {
              if (Object.hasOwnProperty.call(products, key)) {
                const element = products[key];
                productItem = element
                defaultItem.quantity = 1;
                productItem.push(defaultItem)
              }
            }
            ttqTrackEventBuryingPoint('addToCart', productItem)
            /*  ===============================================  TEP-15578 ============================================= */

            const bundleProducts = bundleItems
              ?.map((bundleItem) => {
                let quantity = 0;
                bundleDetailsList.forEach(({ quantities }) => {
                  if (quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`])
                    quantity += quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`];
                });
                if (quantity > 0) return { product: bundleItem, quantity };
              })
              .filter(Boolean);
            await dispatch(
              updateCartDetails({
                id: ONE_PLUS_N_BUNDLE,
                totalQuantity: res?.data?.data?.totalQuantity,
                products: [
                  {
                    product: { ...defaultItem, productBrand: promotionTitle },
                    quantity: bundleDetailsList?.length,
                  },
                  ...(bundleProducts || []),
                ],
              }, 1)
            );
          } else {
            toastMsg(res?.response?.data?.message);
          }
          updateBundleDetailsList(getInitialBundleList());
          setIsAddToCartLoading(false);
        })
        .catch((error) => {
          toastMsg(error?.response?.data?.message || error?.message);
          console.log(error);
          setIsAddToCartLoading(false);
        })
    } catch (error) {
      console.log('error:', error);
      toastMsg(error?.response?.data?.message || error?.message);
      setIsAddToCartLoading(false);
    }
  }
  //  加入購物車
  const onAddToCart = async () => {
    let childBatchSubProductDTO = bundleDetailsList.reduce(
      (childObj, { quantities }, index) => ({
        ...childObj,
        [index + 1]: bundleItems
          .map((item) => {
            const itemQuantity = quantities[`${item.groupId}-${item.itemCode}`];
            if (itemQuantity) {
              return {
                itemCode: item.itemCode,
                quantity: itemQuantity,
                subItemCode: defaultItem.itemCode,
                proportionGroupId: item.groupId
              };
            }
          })
          .filter(Boolean),
      }),
      {}
    );
    try {
      setIsAddToCartLoading(true);
      const res = await addToCart(
        defaultItem.itemCode,
        bundleDetailsList.length,
        {
          childBatchSubProductDTO,
        },
        COMBINATION_CONSIGNEE_ADA,
        CONSIGNEE_TYPE,
        CONSIGNEE_MEMBER_TYPE
      );
      if (res.status === 200) {
        // tealium analytics
        trackAddToCart([defaultItem], [bundleDetailsList?.length], pageDetails);
        /*  ===============================================  TEP-15578 ============================================= */
        let products = bundleDetailsList.reduce(
          (childObj, { quantities }, index) => ({
            ...childObj,
            [index + 1]: bundleItems
              .map((item) => {
                const itemQuantity = quantities[`${item.groupId}-${item.itemCode}`];
                if (itemQuantity) {
                  return {
                    ...item,
                    quantity: itemQuantity,
                  };
                }
              })
              .filter(Boolean),
          }),
          {}
        );
        let productItem = []
        for (const key in products) {
          if (Object.hasOwnProperty.call(products, key)) {
            const element = products[key];
            productItem = element
            defaultItem.quantity = 1;
            productItem.push(defaultItem)
          }
        }
        ttqTrackEventBuryingPoint('addToCart', productItem)
        /*  ===============================================  TEP-15578 ============================================= */

        const bundleProducts = bundleItems
          ?.map((bundleItem) => {
            let quantity = 0;
            bundleDetailsList.forEach(({ quantities }) => {
              if (quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`])
                quantity += quantities[`${bundleItem.groupId}-${bundleItem.itemCode}`];
            });
            if (quantity > 0) return { product: bundleItem, quantity };
          })
          .filter(Boolean);
        await dispatch(
          updateCartDetails({
            id: ONE_PLUS_N_BUNDLE,
            totalQuantity: res?.data?.data?.totalQuantity,
            products: [
              {
                product: { ...defaultItem, productBrand: promotionTitle },
                quantity: bundleDetailsList?.length,
              },
              ...(bundleProducts || []),
            ],
          }, 1)
        );
      } else {
        toastMsg(res?.response?.data?.message);
      }
      updateBundleDetailsList(getInitialBundleList());
      setIsAddToCartLoading(false);
    } catch (err) {
      toastMsg(err?.response?.data?.message || err?.message);
      console.log(err);
      setIsAddToCartLoading(false);
    }
  };

  const renderFooter = () => (
    <>
      <div className={styles["quantity-selector-wrapper"]}>
        <QuantitySelector
          quantity={bundleDetailsList.length}
          onQuantityChange={quantityChangeHandler}
          isLoading={isQuantLoad}
        />
      </div>
      {
        COMBINATION_QUANTITIES &&
          COMBINATION_CONSIGNEE_ADA &&
          CONSIGNEE_TYPE &&
          CONSIGNEE_MEMBER_TYPE &&
          COMBINATION_MASTER_ITEM_CODE &&
          COMBINATION_MASTER_QUANTITY ?
          <div className={styles["add-to-cart-wrapper"]}>
            <Cartbtn
              cartText="更新購物車"
              onAddToCart={updateShoppingCart}
              disableAddToCart={!isProportionMatched || isSetDisabled}
              displayCartIcon={false}
              isLoading={isAddToCartLoading}
            />
          </div>
          :
          <div className={styles["add-to-cart-wrapper"]}>
            <Cartbtn
              cartText="加入購物車"
              onAddToCart={onAddToCart}
              disableAddToCart={!isProportionMatched || isSetDisabled}
              displayCartIcon={false}
              isLoading={isAddToCartLoading}
            />
          </div>
      }

    </>
  );

  const renderGrandTotal = () => <GrandTotal grandTotal={grandTotal} template={template} />;
  const isSetDisabled = isAddToCartDisabled(defaultItem?.productStatus);
  useEffect(() => {
    if (promotionDetails && promotionDetails?.zones && promotionDetails?.zones?.length > 0) {
      let Items = []
      promotionDetails?.zones?.map((zones) => {
        zones?.products?.map((product) => {
          product.groupId = zones?.groupId
          Items.push(product)
        })
      })
      setBundleItems(Items)
    }
  }, [promotionDetails])
  useEffect(() => {
    if (bundleItems.length > 0) {
      setGrandTotal({
        totalPrice: defaultItem?.price ?? 0,
        totalPointVolume: defaultItem?.pointValue ?? 0,
        totalBusinessVolume: defaultItem?.businessVolume ?? 0,
      });
      /*============================================================  TEP-15595  ========================================================*/
      //   3-1-4. N區內商品數: 可配置1個或多個，當N為1時則為固定商品不能讓顧客選擇
      const initialBundleList = getInitialBundleList()
      promotionDetails?.zones?.map((zones) => {
        if (zones?.products?.length == 1) {
          const index = `${zones.products[0].groupId}-${zones.products[0].itemCode}`;
          if (initialBundleList[0].quantities && initialBundleList[0]?.quantities[index] !== undefined) {
            initialBundleList[0].quantities[index] = 1
          }
        }
      })
      setBundleDetailsList(initialBundleList)
      /*============================================================  TEP-15595  ========================================================*/
    }

  }, [bundleItems, promotionDetails]);
  // tealium analytics
  useEffect(() => {
    // TEAL-2330
    let timer;
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      let times = 0;
      timer = setInterval(async () => {
        if (window?.utag && defaultItem) {
          clearInterval(timer)
          await trackProductView({
            product: defaultItem,
            page: pageDetails,
          });
        } else {
          if (times >= 20) {
            clearInterval(timer)
          }
          times++
        }
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [defaultItem]);
  return (
    <>
      <SEOHead NextHead={NextHead} seoConfig={{ pageTitle: promotionTitle }} />
      <BundleWrapper
        Link={Link}
        renderFooter={renderFooter}
        renderGrandTotal={renderGrandTotal}
      >
        <div className={styles["set_container"]}>
          {bundleDetailsList?.map((bundle, index) => (
            <OnePlusnPlusnSet
              defaultItem={defaultItem}
              bundleItems={bundleItems}
              quantities={bundle.quantities}
              key={index}
              onItemQuantityChange={onItemQuantityChange(index)}
              proportion={proportion}
              expanded={bundle.expanded}
              setExpanded={onBundleExpandToggle(index)}
              disableButtons={isLoading}
              setNum={index + 1}
              loadingProduct={loadingProduct}
              promotionDetails={promotionDetails}
              template={template}
            />
          ))}
        </div>
      </BundleWrapper>
    </>
  );
}
